import { RecordOf } from '@opengov/compose-app/immutable';

import { IReportSavedViewEditState } from '../types';

export const ReportSavedViewEditState = RecordOf<IReportSavedViewEditState>({
  // This is for the view tolbar tabs
  // 0 = Data
  // 1 = Presentation
  activeTabIndex: 0,
  ignore: null,
  showSuccessMessage: false,
  activeCategory: { name: '', color: '' }
});
